import React from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import SectionContainer from '../shared/SectionContainer';
import TestimonialCard from '../shared/TestimonialCard';
import ReviewsSection from '../../ReviewsSection';
import useFeaturedReviews from '../../../hooks/useFeaturedReviews';
import { TESTIMONIALS } from '../landingContent';

const MIN_LIVE_REVIEWS = 3;
const LANDING_REVIEW_LIMIT = 3;

const StaticTestimonials = () => (
  <SectionContainer
    id="testimonials"
    title="What Our Community Says"
    subtitle="Real stories from candidates, recruiters, and interviewers on the JobMockAI platform."
    titleId="testimonials-heading"
  >
    <Grid container spacing={3}>
      {TESTIMONIALS.map((item) => (
        <Grid item xs={12} md={4} key={item.name}>
          <TestimonialCard {...item} />
        </Grid>
      ))}
    </Grid>
  </SectionContainer>
);

const TestimonialsSection = () => {
  const { reviews, reviewStats, loading, error } = useFeaturedReviews(LANDING_REVIEW_LIMIT, {
    cacheBust: false,
  });

  if (loading) {
    return (
      <SectionContainer
        id="testimonials"
        title="What Our Community Says"
        subtitle="Real stories from candidates, recruiters, and interviewers on the JobMockAI platform."
        titleId="testimonials-heading"
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress aria-label="Loading reviews" />
        </Box>
      </SectionContainer>
    );
  }

  if (!error && reviews.length >= MIN_LIVE_REVIEWS) {
    return (
      <ReviewsSection
        sectionId="testimonials"
        title="What Our Community Says"
        subtitle="Real feedback from JobMockAI users — candidates, recruiters, and interviewers."
        maxReviews={LANDING_REVIEW_LIMIT}
        showViewAll={false}
        cacheBust={false}
        reviews={reviews}
        reviewStats={reviewStats}
        loading={false}
      />
    );
  }

  return <StaticTestimonials />;
};

export default TestimonialsSection;
